import React, { createRef, useEffect, useRef, useState } from "react";
import CustomSearchBar from "../../../../components/CustomSearchBar/CustomSearchBar";
import { Form, Formik } from "formik";
import close from "../../../../images/icons/close.png";
import add from "../../../../images/icons/add.png";
import * as Yup from "yup";
import FileUpload from "../../../../components/FileUpload/FileUpload";
import CustomInput from "../../../../components/CustomInput/CustomInput";
import edit from "../../../../images/icons/edit.png";
import delete_icon from "../../../../images/icons/delete.png";
import Table from "../../../../components/Table/Table";
import { Box } from "@material-ui/core";
import apiUtil from "../../../../api/apiUtil";
import CustomButton from "../../../../components/CustomButton/custombutton";
import "./MenuList.css";
import CustomSelect from "../../../../components/CustomSelect/CustomSelect";
import api from "../../../../api/api";
import menu_image from "../../../../images/icons/menu.png";
import getToken from "../../../getToken";
import AntFileUpload from "../../../../components/AntFileUpload/AntFileUpload";

const MenuList = () => {
  const [showAddMenuList, setShowAddMenuList] = useState(false);
  const [showEditMenuList, setShowEditMenuList] = useState(false);
  const refMenuListTable = createRef();
  const [menuCategoryDataList, setMenuCategoryDataList] = useState([]);
  const [subCategoryDataList, setSubCategoryDataList] = useState([]);
  const refMenuListForm = useRef(null);
  const refPreviewMenuFiles = useRef(false);
  const refSelectCategory = useRef();
  const refSelectSubCategory = useRef();
  const menuId = useRef(0);
  const [keyword, setKeyword] = useState("");

  const clickAddMenuList = (e) => {
    e.stopPropagation();
    if (showEditMenuList) {
      setShowEditMenuList(false);
      setTimeout(() => setShowAddMenuList(true), 100);
    } else {
      setShowAddMenuList(true);
    }
    bindAPICategoryList();
    setMenuListDetail({});
  };

  const clickBtnClose = () => {
    setShowAddMenuList(false);
    setShowEditMenuList(false);
  };

  const clickDeleteMenu = (rowData) => {
    console.log(rowData);
    if (window.confirm("Are you sure you want to delete this item?")) {
      api
        .post(`Admin/DeleteProduct?productId=${rowData.id}`, {}, getToken())
        .then((result) => {
          apiUtil.parseResult(
            result,
            (response) => {
              if (response.data.statusCode === 401) {
                alert(response.data.message);
                localStorage.removeItem("user");
                window.location.href = "/login";
              } else if (response.data.statusCode === 200) {
                alert(`${productName} deleted successfully!`);
                retrieveMenuList();
                console.log(response.data);
              } else {
                alert(response.data.message);
              }
            },
            (error, type) => {
              alert(error);
            }
          );
        });
    }
  };

  let AddMenuListValidation = Yup.object().shape({
    name: Yup.string().required("Please enter the name."),
    files: Yup.mixed().required("Please choose the image."),
    price: Yup.number().required("Please enter the price."),
    categoryId: Yup.string().required("Please select the category."),
    subCategoryId: Yup.string().required("Please select the sub category."),
    description: Yup.string().required("Please enter the description."),
  });

  // menu category table
  const [menuListData, setMenuListData] = useState({
    isLoading: false,
    grouping: false,
    limit: apiUtil.getDefaultPageSize(),
    data: [],
    total: 0,
    page: 1,
  });

  let brandId = localStorage.getItem("brandId");
  let orgLevel = localStorage.getItem("orgLevel");
  let branchIdMap = {
    "265f0dff-a30a-11ed-b26e-6045bdd63acb":
      "8cd5fe32-a30a-11ed-b26e-6045bdd63acb",
    "e7615a4c-b9e4-11ee-93ac-902e16958ce1":
      "734d09cf-b9e5-11ee-93ac-902e16958ce1",
    default: "8c3d4a7a-699d-11ee-9653-902e16958ce1",
  };
  let branchId = branchIdMap[brandId] || branchIdMap.default;

  const [paramMenuList, setParamMenuList] = useState({
    keyword: "",
    rowLimit: 10,
    currentPage: 1,
    sortBy: "",
    isDesc: true,
    brandId: brandId,
  });

  const checkToken = async () => {
    try {
      const result = await api.post(
        "Admin/GetAllSubCategoryList",
        paramMenuList,
        getToken()
      );
      return apiUtil.parseResult(
        result,
        (response) => {
          return response.data.data;
        },
        (error) => {
          console.log(error);
          throw error;
        }
      );
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  const retrieveMenuList = (value = paramMenuList) => {
    value.keyword = keyword || "";
    if (value.keyword) {
      value.currentPage = 1;
    }
    setMenuListData({
      ...menuListData,
      isLoading: true,
    });

    api.post("Admin/GetProductList", value, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          const data = response.data.data;
          console.log(response);
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.code === 200) {
            setMenuListData({
              isLoading: false,
              limit: data.rowLimit,
              data: data.data && data.data.length > 0 ? data.data : [],
              total: data.totalRecords,
              page: data.paging,
            });
          } else {
            setMenuListData({
              isLoading: false,
              grouping: false,
              limit: 0,
              data: [],
              total: 0,
              page: 0,
            });
          }
        },
        (error, type) => {
          console.log(error);
        }
      );
    });
  };
  console.log(menuListData);

  const bindAPICategoryList = () => {
    api
      .post(
        "Admin/GetCategoryListByAdmin",
        {
          rowLimit: 10,
          currentPage: 1,
          brandId: brandId,
        },
        getToken()
      )
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (checkToken() === null) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              if (response.data.data != null) {
                setMenuCategoryDataList(response.data.data.data);
              }
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });

    // Sub Category List
    api
      .post(
        "Admin/GetAllSubCategoryList",
        {
          rowLimit: 10,
          currentPage: 1,
        },
        getToken()
      )
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            console.log(response.data);
            if (checkToken() === null) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else {
              setSubCategoryDataList(response.data.data);
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
  };

  const menuCategorySelectList = () => {
    return menuCategoryDataList.map((mc) => ({
      label: mc.name,
      value: mc.id,
    }));
  };

  const subCategorySelectList = () => {
    if (!Array.isArray(subCategoryDataList)) {
      return [];
    }

    return subCategoryDataList.map((subCategory) => ({
      label: subCategory.name,
      value: subCategory.id,
    }));
  };

  const handleSubCategoriesItem = async (categoryId) => {
    try {
      const result = await api.get(
        "Admin/GetSubCategoryByCategoryId",
        { categoryId },
        getToken()
      );
      return apiUtil.parseResult(
        result,
        (response) => {
          console.log(response.data);
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.value.code === 200) {
            setSubCategoryDataList(
              response.data.value.data && response.data.value.data.length > 0
                ? response.data.value.data
                : []
            );
          } else {
            throw new Error(response.data.value.statusText);
          }
        },
        (error, type) => {
          console.log(error);
          throw error;
        }
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const handleCategoryChange = async (selectedCategoryId) => {
    try {
      if (selectedCategoryId) {
        const subCategoryData = await handleSubCategoriesItem(
          selectedCategoryId
        );
        if (subCategoryData) {
          console.log("Subcategory Data:", subCategoryData);
        } else {
          console.log("No subcategories found.");
        }
      } else {
        console.log(selectedCategoryId);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleMenuListSubmit = (values, actions) => {
    const imageInfo = [];

    values.files.forEach((file) => {
      imageInfo.push({
        imageName: file.name,
        image: file.url.replace(/^data:(.*,)?/, ""),
      });
    });

    const menuList = {
      brandId: brandId,
      branchId: branchId,
      isAvailable: true,
      name: values.name,
      price: values.price,
      categoryId: values.categoryId,
      subCategoryId: values.subCategoryId,
      description: values.description,
      productImageList: imageInfo,
    };

    console.log(menuList);

    api.post("Admin/CreateProduct", menuList, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          console.log(response.data.value);
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.value.code === 200) {
            alert(`New ${productName} is saved successfully.`);
            // refresh the table
            retrieveMenuList(paramMenuList);

            // reset the inputs and clear values
            actions.resetForm();
            values = {};
            setShowAddMenuList(false);
            // refSelectCategory.current.clearValue();
            // refSelectSubCategory.current.clearValue();
            console.log(refMenuListForm);
            for (let i = 0; i < refMenuListForm.current.length - 2; i++) {
              refMenuListForm.current[i].value = "";
            }
            // clear preview images
            refPreviewMenuFiles.current = false;
          }
        },
        (error, type) => {
          console.log(error);
        }
      );
    });

    actions.setSubmitting(false);
  };

  const [menuListDetail, setMenuListDetail] = useState({});

  const clickBtnEditMenuList = (e, id) => {
    e.stopPropagation();
    clickBtnClose();
    getMenuListDetail(id);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  };

  const getMenuListDetail = (id) => {
    bindAPICategoryList();
    api
      .get("Admin/GetProductById", { productId: id }, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            const data = response.data.value.data;
            console.log(response);
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.value.code === 200) {
              setMenuListDetail({
                name: data.title ?? "",
                image: data.image ?? "",
                price: data.price ?? "",
                categoryId: data.categoryId ?? "",
                subCategoryId: data.subCategoryId ?? "",
                description: data.description ?? "",
                imageList: data.images ?? "",
              });
              refPreviewMenuFiles.current = true;
              setShowEditMenuList(true);
              menuId.current = id;
              if (response.data.value.data.categoryId) {
                handleCategoryChange(response.data.value.data.categoryId);
              }
            } else {
              alert(response.data.value.statusText);
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
  };

  const editMenuListSubmit = (values, actions) => {
    const imageInfo = [];

    values.files.forEach((file) => {
      imageInfo.push({
        imageName: file.name,
        image: file.url.replace(/^data:(.*,)?/, ""),
      });
    });

    const menuList = {
      id: menuId.current,
      name: values.name,
      price: values.price,
      description: values.description,
      isAvailable: true,
      categoryId: values.categoryId,
      subCategoryId: values.subCategoryId,
      brandId: brandId,
      branchId: branchId,
      productImageList: imageInfo,
    };

    console.log(menuList);

    api.post("Admin/UpdateProduct", menuList, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          console.log(response);
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.value.code === 200) {
            alert(`${productName} is updated successfully.`);

            actions.resetForm();
            values = {};
            setShowEditMenuList(false);
            refPreviewMenuFiles.current = false;
            retrieveMenuList(paramMenuList);
          } else {
            alert(response.data.statusText);
          }
        },
        (error, type) => {
          console.log(error);
        }
      );
    });

    actions.setSubmitting(false);
  };

  useEffect(() => {
    retrieveMenuList();
    bindAPICategoryList();
  }, [paramMenuList]);

  const orgLevelMap = {
    1: "Room List",
    2: "Service List",
    3: "Menu List",
  };
  const orgLevelString = orgLevelMap[orgLevel] || "";

  const addButtonLabels = {
    1: "Add Room List",
    2: "Add Service List",
    3: "Add Menu List",
  };
  const addButtonLabel = addButtonLabels[orgLevel] || "";

  const labelMap = {
    1: "Room",
    2: "Service",
    3: "Category",
  };

  const placeholderMap = {
    1: "Select Room",
    2: "Select Service",
    3: "Select Category",
  };

  const productMap = {
    1: "Room",
    2: "Service",
    3: "Menu",
  };

  const productName = productMap[orgLevel] || "";
  const label = labelMap[orgLevel] || "";
  const placeholder = placeholderMap[orgLevel] || "";

  const subLabelMap = {
    1: "Room Type",
    2: "Service Type",
    3: "Sub Category",
  };

  const subPlaceholderMap = {
    1: "Select Room Type",
    2: "Select Service Type",
    3: "Select Sub Category",
  };

  const getProductFiles = () => {
    if (menuListDetail.imageList) {
      return menuListDetail.imageList.map((image, index) => ({
        uid: index.toString(),
        status: "done",
        url: image.image,
        name: image.imageName,
      }));
    } else {
      return null;
    }
  };

  const subLabel = subLabelMap[orgLevel] || "";
  const subPlaceholder = subPlaceholderMap[orgLevel] || "";

  console.log(menuListDetail);

  return (
    <>
      {showAddMenuList || showEditMenuList ? (
        <>
          <div className=" Actions space_between">
            <h6 className="title_text mt-2">{orgLevelString}</h6>
            <button className="btn btnClose" onClick={clickBtnClose}>
              <img src={close} className="imgClose" alt="imgClose" />
            </button>
          </div>
          <div className="menu-list-form">
            <Formik
              initialValues={{
                name: menuListDetail.name ? menuListDetail.name : "",
                price: menuListDetail.price ? menuListDetail.price : "",
                categoryId: menuListDetail.categoryId
                  ? menuListDetail.categoryId
                  : "",
                subCategoryId: menuListDetail.subCategoryId
                  ? menuListDetail.subCategoryId
                  : "",
                description: menuListDetail.description
                  ? menuListDetail.description
                  : "",
                files: getProductFiles(),
              }}
              enableReinitialize={true}
              validationSchema={AddMenuListValidation}
              validateOnBlur={false}
              onSubmit={(values, actions) => {
                if (showEditMenuList) {
                  editMenuListSubmit(values, actions);
                } else {
                  handleMenuListSubmit(values, actions);
                }
              }}
            >
              {({ errors, touched, values, setFieldValue }) => (
                <Form
                  ref={refMenuListForm}
                  className="row form-container product-form"
                >
                  <div className="col-6 mt-2">
                    <CustomInput
                      name="name"
                      type="text"
                      label="Name"
                      customclass="input_wrapper"
                      hideicon="true"
                    />
                  </div>

                  <div className="col-6 mt-2">
                    <CustomInput
                      name="price"
                      type="text"
                      label="Price"
                      customclass="input_wrapper"
                      hideicon="true"
                      icontext="MMK"
                    />
                  </div>

                  <div className="col-6 mt-2">
                    <CustomSelect
                      options={menuCategorySelectList()}
                      name="categoryId"
                      label={label}
                      isClearable={false}
                      placeholder={placeholder}
                      refSelect={refSelectCategory}
                      onChange={(selectedOption) => {
                        handleCategoryChange(selectedOption.value);
                        setFieldValue("categoryId", selectedOption.value);
                        setFieldValue("subCategoryId", "");
                      }}
                    />
                  </div>

                  <div className="col-6 mt-2">
                    <CustomSelect
                      options={subCategorySelectList()}
                      name="subCategoryId"
                      label={subLabel}
                      isClearable={true}
                      placeholder={subPlaceholder}
                      refSelect={refSelectSubCategory}
                      onChange={(selectedOption) => {
                        setFieldValue(
                          "subCategoryId",
                          selectedOption ? selectedOption.value : ""
                        );
                      }}
                    />
                  </div>

                  <div className="col-12 mt-2">
                    <CustomInput
                      name="description"
                      label="Description"
                      textarea="true"
                    />
                  </div>

                  <div className="col-12 mt-2">
                    <AntFileUpload
                      label="Image"
                      name="files"
                      addIcon={true}
                      inputText="Drag and drop or browse to choose a file"
                      aspectRatio={9 / 3}
                      imageQuality={0.8}
                      accept="image/*"
                      onChange={({ fileList: newFileList }) => {
                        if (newFileList.length > 0) {
                          newFileList = newFileList.map((file) => ({
                            ...file,
                            status: "done",
                            percent: 100,
                            response: "Success",
                          }));
                          const successFiles = newFileList.filter(
                            (file) => file.status !== "error"
                          );
                          const failedFiles = newFileList.filter(
                            (file) => file.status === "error"
                          );
                          if (failedFiles.length > 0) {
                            console.log(failedFiles);
                          }
                          setFieldValue("files", successFiles);
                        } else {
                          setFieldValue("files", null);
                        }
                      }}
                      onRemove={(file) => {
                        if (file.url) {
                          setFieldValue("deletedImage", [
                            ...values.deletedImage,
                            file,
                          ]);
                        }
                        if (values.files.length === 1) {
                          setFieldValue("files", null);
                        }
                      }}
                    />
                  </div>

                  <div className="col-12 mt-3">
                    <div className="Actions justify-content-end">
                      <button
                        type="button"
                        className="button btnCancel"
                        onClick={clickBtnClose}
                      >
                        Cancel
                      </button>
                      <button type="submit" className="button btnSave">
                        {showAddMenuList ? "Create" : "Update"}
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </>
      ) : null}

      <div className=" Actions space_between">
        <h6 className="title_text mt-2">{orgLevelString}</h6>
        <div className="d-flex justify-content-end gap-16 align-items-center">
          <CustomSearchBar
            value={keyword}
            setValue={setKeyword}
            onSearch={() => retrieveMenuList()}
          />
          {!showAddMenuList && (
            <CustomButton
              icon={add}
              text={addButtonLabel}
              addIcon={true}
              className="btnAdd"
              onClick={(e) => clickAddMenuList(e)}
            />
          )}
        </div>
      </div>

      <div className="table_container menu_list_table">
        <Table
          key={menuListData.total}
          ref={refMenuListTable}
          maxBodyHeight={menuListData.limit * 50}
          isLoading={menuListData.isLoading}
          grouping={menuListData.grouping}
          limit={menuListData.limit}
          data={menuListData.data}
          total={menuListData.total}
          page={menuListData.page}
          onPageChange={(page) => {
            setParamMenuList({
              ...paramMenuList,
              currentPage: page,
            });
            retrieveMenuList(paramMenuList);
          }}
          columns={[
            {
              title: "No",
              render: (row) => {
                const startingIndex =
                  (menuListData.page - 1) * menuListData.limit + 1;
                return startingIndex + row.tableData.index;
              },
              width: "80px",
              align: "center",
            },
            {
              title: "Image",
              render: (row) => {
                if (row.images == null || row.images == "") {
                  row.images = menu_image;
                }
                return (
                  <img
                    src={row.images[0].image}
                    alt=""
                    className="d-block imgProduct"
                    onError={(e) => (e.target.src = menu_image)}
                  />
                );
              },
              width: "170px",
            },
            {
              title: "Name",
              render: (row) => {
                if (row.title.length > 40) {
                  return row.title.substring(0, 39) + "...";
                }
                return row.title;
              },
              width: "180px",
            },
            {
              title: "Price",
              render: (row) => {
                return row.price + " MMK";
              },
              width: "150px",
            },
            {
              title: "Description",
              render: (row) => {
                if (row.description.length > 40) {
                  return row.description.substring(0, 39) + "...";
                }
                return row.description;
              },
              width: "350px",
            },
            {
              title: "Edit",
              render: (row) => {
                return (
                  <Box
                    className=" cursor-pointer"
                    onClick={(e) => clickBtnEditMenuList(e, row.id)}
                  >
                    <img src={edit} alt="" className="imgIcon" />
                  </Box>
                );
              },
              align: "center",
              sorting: false,
              width: "80px",
            },
            {
              title: "Delete",
              render: (row) => {
                return (
                  <Box
                    style={{ cursor: "pointer" }}
                    onClick={() => clickDeleteMenu(row)}
                  >
                    <img src={delete_icon} alt="" className="imgIcon" />
                  </Box>
                );
              },
              align: "center",
              sorting: false,
              width: "80px",
            },
          ]}
        />
      </div>
    </>
  );
};

export default MenuList;
